export const FETCH_ORGANIZATIONS_REQUEST =
    '@@organizations/FETCH_ORGANIZATIONS_REQUEST';
export const FETCH_ORGANIZATIONS_SUCCESS =
    '@@organizations/FETCH_ORGANIZATIONS_SUCCESS';
export const FETCH_ORGANIZATIONS_FAILURE =
    '@@organizations/FETCH_ORGANIZATIONS_FAILURE';

export const FETCH_ORGANIZATION_BUCKETS_REQUEST =
    '@@organizations/FETCH_ORGANIZATION_BUCKETS_REQUEST';
export const FETCH_ORGANIZATION_BUCKETS_SUCCESS =
    '@@organizations/FETCH_ORGANIZATION_BUCKETS_SUCCESS';
export const FETCH_ORGANIZATION_BUCKETS_FAILURE =
    '@@organizations/FETCH_ORGANIZATION_BUCKETS_FAILURE';

export const FETCH_BUCKET_REQUEST = '@@organizations/FETCH_BUCKET_REQUEST';
export const FETCH_BUCKET_SUCCESS = '@@organizations/FETCH_BUCKET_SUCCESS';
export const FETCH_BUCKET_FAILURE = '@@organizations/FETCH_BUCKET_FAILURE';

export const FETCH_ORGANIZATION_MEMBERS_REQUEST =
    '@@organizations/FETCH_ORGANIZATION_MEMBERS_REQUEST';
export const FETCH_ORGANIZATION_MEMBERS_SUCCESS =
    '@@organizations/FETCH_ORGANIZATION_MEMBERS_SUCCESS';
export const FETCH_ORGANIZATION_MEMBERS_FAILURE =
    '@@organizations/FETCH_ORGANIZATION_MEMBERS_FAILURE';

export const FETCH_ORGANIZATION_GA_SETTINGS_REQUEST =
    '@@organizations/FETCH_ORGANIZATION_GA_SETTINGS_REQUEST';
export const FETCH_ORGANIZATION_GA_SETTINGS_SUCCESS =
    '@@organizations/FETCH_ORGANIZATION_GA_SETTINGS_SUCCESS';
export const FETCH_ORGANIZATION_GA_SETTINGS_FAILURE =
    '@@organizations/FETCH_ORGANIZATION_GA_SETTINGS_FAILURE';

export const CHANGE_ORGANIZATION_BUCKETS_SEARCH =
    '@@organizations/CHANGE_ORGANIZATION_BUCKETS_SEARCH';

export const CHANGE_NEW_BUCKET_NAME = '@@organizations/CHANGE_NEW_BUCKET_NAME';
export const CHANGE_NEW_BUCKET_DESCRIPTION =
    '@@organizations/CHANGE_NEW_BUCKET_DESCRIPTION';
export const CHANGE_NEW_BUCKET_APPLICATION_PERMISSIONS_IDS =
    '@@organizations/CHANGE_NEW_BUCKET_APPLICATION_PERMISSIONS_IDS';
export const NEW_BUCKET_REQUEST = '@@organizations/NEW_BUCKET_REQUEST';
export const NEW_BUCKET_SUCCESS = '@@organizations/NEW_BUCKET_SUCCESS';
export const NEW_BUCKET_FAILURE = '@@organizations/NEW_BUCKET_FAILURE';

export const DELETE_BUCKET_REQUEST = '@@buckets/DELETE_BUCKET_REQUEST';
export const DELETE_BUCKET_SUCCESS = '@@buckets/DELETE_BUCKET_SUCCESS';
export const DELETE_BUCKET_FAILURE = '@@buckets/UPDATE_BUCKET_FAILURE';

export const CHANGE_ORGANIZATION_SETTINGS_NAME =
    '@@organizations/CHANGE_ORGANIZATION_SETTINGS_NAME';
export const CHANGE_ORGANIZATION_SETTINGS_GA =
    '@@organizations/CHANGE_ORGANIZATION_SETTINGS_GA';
export const RESET_ORGANIZATION_SETTINGS =
    '@@organizations/RESET_ORGANIZATION_SETTINGS';
export const UPDATE_ORGANIZATION_SETTINGS_REQUEST =
    '@@organizations/UPDATE_ORGANIZATION_SETTINGS_REQUEST';
export const UPDATE_ORGANIZATION_SETTINGS_SUCCESS =
    '@@organizations/UPDATE_ORGANIZATION_SETTINGS_SUCCESS';
export const UPDATE_ORGANIZATION_SETTINGS_FAILURE =
    '@@organizations/UPDATE_ORGANIZATION_SETTINGS_FAILURE';
export const UPDATE_ORGANIZATION_SETTINGS_SKIP =
    '@@organizations/UPDATE_ORGANIZATION_SETTINGS_SKIP';
export const UPDATE_ORGANIZATION_GA_SETTINGS_SKIP =
    '@@organizations/UPDATE_ORGANIZATION_GA_SETTINGS_SKIP';

export const UPDATE_ORGANIZATION_AVATAR_REQUEST =
    '@@organizations/UPDATE_ORGANIZATION_AVATAR_REQUEST';
export const UPDATE_ORGANIZATION_AVATAR_SUCCESS =
    '@@organizations/UPDATE_ORGANIZATION_AVATAR_SUCCESS';
export const UPDATE_ORGANIZATION_AVATAR_FAILURE =
    '@@organizations/UPDATE_ORGANIZATION_AVATAR_FAILURE';

export const UPDATE_ORGANIZATION_GA_SETTINGS_SUCCESS =
    '@@organizations/UPDATE_ORGANIZATION_GA_SETTINGS_SUCCESS';
export const UPDATE_ORGANIZATION_GA_SETTINGS_FAILURE =
    '@@organizations/UPDATE_ORGANIZATION_GA_SETTINGS_FAILURE';

/* User actions in organization */
export const CHANGE_USERS_ROLE_REQUEST =
    '@@organizations/CHANGE_USERS_ROLE_REQUEST';
export const CHANGE_USERS_ROLE_SUCCESS =
    '@@organizations/CHANGE_USERS_ROLE_SUCCESS';
export const CHANGE_USERS_ROLE_FAILURE =
    '@@organizations/CHANGE_USERS_ROLE_FAILURE';
export const REMOVE_USERS_REQUEST = '@@organizations/REMOVE_USERS_REQUEST';
export const REMOVE_USERS_SUCCESS = '@@organizations/REMOVE_USERS_SUCCESS';
export const REMOVE_USERS_FAILURE = '@@organizations/REMOVE_USERS_FAILURE';

export const CURRENT_USER_ROLE_CHANGE_SUCCESS =
    '@@organizations/CURRENT_USER_ROLE_CHANGE_SUCCESS';

/* User search */
export const USER_SEARCH_REQUEST = '@@organizations/USER_SEARCH_REQUEST';
export const USER_SEARCH_SUCCESS = '@@organizations/USER_SEARCH_SUCCESS';
export const USER_SEARCH_FAILURE = '@@organizations/USER_SEARCH_FAILURE';

/* Add members */
export const ADD_ORGANIZATION_MEMBERS_REQUEST =
    '@@organizations/ADD_ORGANIZATION_MEMBERS_REQUEST';
export const ADD_ORGANIZATION_MEMBERS_SUCCESS =
    '@@organizations/ADD_ORGANIZATION_MEMBERS_SUCCESS';
export const ADD_ORGANIZATION_MEMBERS_FAILURE =
    '@@organizations/ADD_ORGANIZATION_MEMBERS_FAILURE';
export const TOGGLE_ADD_MEMBER = '@@organizations/TOGGLE_ADD_MEMBER';

/* Invite members */
export const INVITE_ORGANIZATION_MEMBER_REQUEST =
    '@@organizations/INVITE_ORGANIZATION_MEMBER_REQUEST';
export const INVITE_ORGANIZATION_MEMBER_SUCCESS =
    '@@organizations/INVITE_ORGANIZATION_MEMBER_SUCCESS';
export const INVITE_ORGANIZATION_MEMBER_FAILURE =
    '@@organizations/INVITE_ORGANIZATION_MEMBER_FAILURE';

export const FETCH_ORGANIZATION_MEMBER_INVITATIONS_REQUEST =
    '@@organizations/FETCH_ORGANIZATION_MEMBER_INVITATIONS_REQUEST';
export const FETCH_ORGANIZATION_MEMBER_INVITATIONS_SUCCESS =
    '@@organizations/FETCH_ORGANIZATION_MEMBER_INVITATIONS_SUCCESS';
export const FETCH_ORGANIZATION_MEMBER_INVITATIONS_FAILURE =
    '@@organizations/FETCH_ORGANIZATION_MEMBER_INVITATIONS_FAILURE';

export const RESEND_ORGANIZATION_MEMBER_INVITATIONS_REQUEST =
    '@@organizations/RESEND_ORGANIZATION_MEMBER_INVITATIONS_REQUEST';
export const RESEND_ORGANIZATION_MEMBER_INVITATIONS_SUCCESS =
    '@@organizations/RESEND_ORGANIZATION_MEMBER_INVITATIONS_SUCCESS';
export const RESEND_ORGANIZATION_MEMBER_INVITATIONS_FAILURE =
    '@@organizations/RESEND_ORGANIZATION_MEMBER_INVITATIONS_FAILURE';

export const REVOKE_ORGANIZATION_MEMBER_INVITATIONS_REQUEST =
    '@@organizations/REVOKE_ORGANIZATION_MEMBER_INVITATIONS_REQUEST';
export const REVOKE_ORGANIZATION_MEMBER_INVITATIONS_SUCCESS =
    '@@organizations/REVOKE_ORGANIZATION_MEMBER_INVITATIONS_SUCCESS';
export const REVOKE_ORGANIZATION_MEMBER_INVITATIONS_FAILURE =
    '@@organizations/REVOKE_ORGANIZATION_MEMBER_INVITATIONS_FAILURE';

/* Members filter */
export const CHANGE_ORGANIZATION_MEMBERS_FILTER =
    '@@organizations/CHANGE_ORGANIZATION_MEMBERS_FILTER';

/* Report */
export const REPORT_REQUEST = '@@organizations/REPORT_REQUEST';
export const REPORT_SUCCESS = '@@organizations/REPORT_SUCCESS';
export const REPORT_FAILURE = '@@organizations/REPORT_FAILURE';
export const DOWNLOAD_REPORT_REQUEST =
    '@@organizations/DOWNLOAD_REPORT_REQUEST';



// WEBPACK FOOTER //
// ./src/constants/organizations.js